export default __webpack_public_path__ + "static/media/earphones9.9a74ca4a.jfif";